import React from 'react'
import Table from '@cloudscape-design/components/table'

// https://cloudscape.design/components/table
export function RadTable ({ ...rest }) {
  return (
    <Table {...rest} />
  )
}
